import "../crc32-LCGpXEbE.js";
import { L as c, D as s, A as o } from "../constants-IFi5pBQh.js";
const l = () => {
  const a = new URLSearchParams(window.location.search).get("lang"), t = localStorage.getItem(c);
  if (a) {
    const e = a.toUpperCase();
    return localStorage.setItem(c, e), e;
  }
  return t || s;
}, u = (n) => {
  if (n.toUpperCase() === "ACH") {
    const t = document.createElement("script");
    t.type = "text/javascript", t.text = `
            var _jipt = []; _jipt.push(['project', 'deriv-app']);
            var crowdin = document.createElement("script");
            crowdin.setAttribute('src', '//cdn.crowdin.com/jipt/jipt.js');
            document.head.appendChild(crowdin);
        `, document.head.appendChild(t);
  }
}, d = (n = []) => {
  const a = ["ACH", ...n];
  return Object.keys(o).filter((e) => !a.includes(e)).reduce((e, r) => (e[r] = o[r], e), {});
};
export {
  d as getAllowedLanguages,
  l as getInitialLanguage,
  u as loadIncontextTranslation
};
